module.exports = __webpack_public_path__ + "img/icon-download-white.1d40a0f4.svg";